import { I18nService } from '../utils/i18n.service';
import { Pipe, PipeTransform } from '@angular/core';

/** Pipe to get the localized length of a string. */
@Pipe({ name: 'localizedLength', standalone: true })
export class LocalizedLengthPipe implements PipeTransform {
	constructor(private readonly i18n: I18nService) {}
	/** Pipe to get the localized length of a string. */
	transform(value: LocaleValue | undefined): number {
		const text = this.i18n.getText(value);
		return text?.length || 0;
	}
}
